import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Play, Star, ShieldCheck } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-black min-h-screen flex flex-col pt-32 pb-0 overflow-hidden" data-id="element-143" data-mp="eilex7b0aze3">
      {/* Subtle radial glow background */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(245,158,11,0.08),transparent_60%)] pointer-events-none" data-id="element-144" data-mp="4lywsqa2emfr" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full flex-1 flex flex-col justify-center" style={{
      paddingBottom: "0px"
    }} data-id="element-145" data-mp="1285wpmvfbqls">
        {/* Main Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.08] tracking-tight mb-8" data-id="element-146" data-mp="s9zxxe4wz0l5">
          Tu Mal Crédito No Debería
          <br data-id="element-147" data-mp="3814brpijjyoc" />
          <span className="italic font-black bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-148" data-mp="384s4wnk2qj2j">
            Seguir Frenando Tus Sueños
          </span>
        </motion.h1>

        {/* Subheadline */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.25,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-lg md:text-xl text-white/50 font-light leading-relaxed max-w-2xl mx-auto mb-12" data-id="element-149" data-mp="39b4fyxmj3o1c">
          Te ayudamos a restaurarlo para que puedas calificar a comprar tu casa,
          carro y tener acceso a capital.
        </motion.p>

        {/* CTAs */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col sm:flex-row gap-5 items-center justify-center mb-16" data-id="element-150" data-mp="2qhqtzi0smrxv">
          <a href="https://calendly.com/vantixcredit/diagnostico-de-credito" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-gradient-to-b from-amber-300 via-amber-400 to-amber-600 hover:brightness-110 text-black font-semibold px-7 py-4 rounded-full transition-all text-base shadow-xl shadow-amber-500/20" data-id="element-151" data-mp="2ljpbozb6ywng">
            Agenda tu diagnóstico gratis
            <ArrowRight className="h-4 w-4" data-id="element-152" data-mp="ddnenyoiclid" />
          </a>
          <a href="#vsl" className="flex items-center gap-3 text-white/80 hover:text-white transition-colors text-base font-medium" data-id="element-153" data-mp="db2fjhflgjob">
            <span className="h-9 w-9 rounded-full bg-white/10 border border-white/20 flex items-center justify-center" data-id="element-154" data-mp="161az9dps3c50">
              <Play className="h-3.5 w-3.5 text-white fill-white ml-0.5" data-id="element-155" data-mp="111omt6hrxzx9" />
            </span>
            Ver cómo funciona
          </a>
        </motion.div>
      </div>
    </section>;
}